import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SelectOption } from '../../services/data-form/data-form.service';

@Component({
	selector: 'pcm-data-form-field-select',
	templateUrl: './data-form-field-select.component.html',
	styleUrls: ['./data-form-field-select.component.scss']
})
export class DataFormFieldSelectComponent implements OnChanges, OnInit {
	@Input() name: string;
	@Input() propName: string;
	@Input() formGroup: UntypedFormGroup;
	@Input() helpMessage: string;
	@Input() invalid = false;
	@Input() invalidText: string;
	@Input() warn = false;
	@Input() warnText: string;
	@Input() required = false;
	@Input() options: Array<SelectOption>;
	// value and valueChange, used as ([value]), is an optional property in case an
	// ngModel-like object is being used to drive the value of the field instead of a formGroup
	@Input() value: string;
	@Output() valueChange = new EventEmitter<string>();
	optionsInternal = [];

	constructor(private formBuilder: UntypedFormBuilder) {}
	
	ngOnInit() {
		// if formGroup isn't passed in, then create a basic form group so it doesn't throw errors
		if (!this.formGroup) {
			const propNameToUse = this.propName ? this.propName : 'prop';
			this.formGroup = this.formBuilder.group({ [propNameToUse]: {value: this.value} });
			this.propName = propNameToUse;
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['options']) {
			const newOptions = changes['options'].currentValue;
			newOptions.forEach(option => {
				// carbon component needs 'content' prop, so pass in either content or name, which ever is defined
				option.content = option.content ?? option.name;
				option.selected = option.id === this.value;
			});
			this.optionsInternal = newOptions;
		}
	}

	changeValue(selectedValue): void {
		this.valueChange.emit(selectedValue.item.id);
	}
}
